class BenefitCorporateRecognitionUIModel {
  constructor({
    preferredSeats = undefined,
    clid = undefined,
    seatCode = undefined,
  } = {}) {
    this.preferredSeats = preferredSeats;
    this.clid = clid;
    this.seatCode = seatCode;
  }
}

export default BenefitCorporateRecognitionUIModel;